var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"reason",style:({
    backgroundColor: _setup.getReasonBackgroundColor(_setup.props.reason),
    color: _setup.getReasonTextColor(_setup.props.reason),
  })},[_vm._v(" "+_vm._s(_setup.props.reasonOptions?.find(r => _setup.props.reason === r.name)?.display_value || _setup.props.reason)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }